// extracted by css-extract-rspack-plugin
module.exports =  {"appoint-menu":"AppointMenu-zkD4__appoint-menu","button":"AppointMenu-LmSP__button"};